__turbopack_context__.v({
  "block": "lOx7FW_block",
  "label": "lOx7FW_label",
  "root": "lOx7FW_root",
  "rootMobile": "lOx7FW_rootMobile",
  "row": "lOx7FW_row",
});
